<template>
    <v-container>
        <v-dialog v-model="dialogUpline" transition="dialog-bottom-transition" max-width="600">
            <template>
                <v-card>
                    <!-- <v-toolbar color="primary" dark>List Upline</v-toolbar> -->
                    <v-card-title class="text-h5 primary lighten-2">
                        List Upline
                    </v-card-title>
                    <v-card-text>
                        <v-text-field dense v-model="namaUpline" label="Nama" outlined hide-details="auto"
                            class="mt-5"></v-text-field>
                        <v-text-field dense v-model="nikUpline" label="NIK" outlined hide-details="auto"></v-text-field>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn elevation="2" outlined @click="loadInquiryUpline">Search</v-btn>
                        <v-btn elevation="2" outlined @click="dialogDlc = false">Clear</v-btn>
                    </v-card-actions>
                    <v-data-table @click:row="getValueUpline" v-if="uplineList.length > 0" mobile-breakpoint="0" dense
                        :headers="headersUpline" :items="uplineList" item-key="name"
                        class="elevation-1 pa-2"></v-data-table>
                </v-card>
            </template>
        </v-dialog>
        <v-dialog v-model="dialogAtasan" transition="dialog-bottom-transition" max-width="600">
            <template>
                <v-card>
                    <v-card-title class="text-h5 primary lighten-2">
                        List Atasan
                    </v-card-title>
                    <v-card-text>
                        <v-text-field dense v-model="namaAtasan" label="Nama" outlined hide-details="auto"
                            class="mt-5"></v-text-field>
                        <v-text-field dense v-model="nikAtasan" label="NIK" outlined hide-details="auto"></v-text-field>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn elevation="2" outlined @click="loadInquiryPicDealer">Search</v-btn>
                        <v-btn elevation="2" outlined @click="dialogDlc = false">Clear</v-btn>
                    </v-card-actions>
                    <v-data-table @click:row="getValueAtasan" v-if="atasanList ? atasanList.length > 0 : false"
                        mobile-breakpoint="0" dense :headers="headersAtasan" :items="atasanList" item-key="name"
                        class="elevation-1 pa-2"></v-data-table>
                </v-card>
            </template>
        </v-dialog>
        <v-dialog v-model="dialogInputAtasan" transition="dialog-bottom-transition" max-width="600">
            <v-card>
                <v-card-title>
                    {{ titleDialog }}
                </v-card-title>
                <v-card-text>
                    <v-text-field @click="openDialogAtasan" dense v-model="nama" label="Nama" outlined
                        hide-details="auto"></v-text-field>
                    <v-text-field dense v-model="nik" label="NIK" disabled outlined hide-details="auto"
                        class="mt-2"></v-text-field>
                    <v-text-field dense class="mt-2" v-model="accountNumber" label="Nomor Rekening" disabled outlined
                        hide-details="auto"></v-text-field>
                    <v-text-field dense class="mt-2" v-model="position" label="Jabatan" disabled outlined
                        hide-details="auto"></v-text-field>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn elevation="2" outlined @click.stop="dialogInputAtasan = false">Cancel</v-btn>
                    <v-btn elevation="2" outlined @click="handleAddAtasan">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="text-h5">
                    Caution
                </v-card-title>
                <v-card-text>Apakah anda yakin ingin menghapus salah satu atasan ?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog = false">
                        No
                    </v-btn>
                    <v-btn color="green darken-1" text @click="handleDeleteAtasan(idForDeleteAtasan)">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <template v-if="detailUplineList">
            <div class="my-5" v-for="(item, index) in detailUplineList" :key="index">
                <v-row>
                    <v-checkbox v-if="modeDelete" hide-details class="shrink mr-2 mt-0" v-model="arrayToSaveDelete"
                        :value="item.uplineId"></v-checkbox>
                    <v-text-field dense v-model="item.personName" label="NIK Upline (Sales Officer)" outlined
                        hide-details="auto" @click="openDialog(item.uplineId)"></v-text-field>
                </v-row>
            </div>
            <template>
                <v-row v-if="doneProcess" class="justify-end">
                    <v-btn v-if="detailUplineList.length > 1" @click.stop="modeDelete = true, doneProcess = false" outlined
                        icon rounded>
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn class="mx-2" @click.stop="openDialog('')" outlined icon rounded>
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-row>
                <v-row v-if="!doneProcess" class="justify-end">
                    <v-btn elevation="2" outlined @click.stop="cancelProses">Cancel</v-btn>
                    <v-btn v-if="modeDelete" class="mx-2" elevation="2" outlined @click="handleDeleteUpline">Delete</v-btn>
                    <v-btn v-else class="mx-2" elevation="2" outlined @click="handleAddUpline">Simpan</v-btn>
                </v-row>
                <!-- <v-row v-if="modeDelete" class="justify-end">
                    <v-btn elevation="2" outlined @click.stop="cancelProses">Cancel</v-btn>
                    <v-btn class="mx-2" elevation="2" outlined @click="handleAddUpline">Delete</v-btn>
                </v-row> -->
            </template>
            <!-- <v-card v-for="(item, index) in detailUplineList" :key="index" @click="openDialog(item.id)" class="mx-auto my-5"
                rounded="5" max-width="344" outlined>
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h5 mb-1">
                            {{ item.userName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ item.personName }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-card-actions>
                        <v-btn @click.stop="dialog = true, idForDeleteAtasan = item.id" icon rounded>
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-list-item>
            </v-card> -->
        </template>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            dialogUpline: false,
            namaUpline: "",
            nikUpline: "",
            uplineList: [],
            idUplineNik: "",
            headersUpline: [
                {
                    text: 'NIK',
                    value: 'oid',
                    class: "primary black--text",
                },
                { text: 'Nama', value: 'personName', class: "primary black--text", },
            ],
            newUpline: {},
            doneProcess: true,
            modeDelete: false,
            arrayToSaveDelete: [],

            detailUplineList: [],
            dialogAtasan: false,
            namaAtasan: "",
            nikAtasan: "",
            atasanList: "",
            dialogInputAtasan: false,
            nama: "",
            nik: "",
            accountNumber: "",
            position: "",
            dialog: false,
            idForDeleteAtasan: "",
            headersAtasan: [
                {
                    text: 'NIK',
                    value: 'nik',
                    class: "primary black--text",
                },
                { text: 'Nama', value: 'name', class: "primary black--text", },
                { text: 'No Rek', value: 'accountNumber', class: "primary black--text", },
                { text: 'Jabatan', value: 'position', class: "primary black--text", },
            ],
            titleDialog: "Tambah Atasan",
            isEdit: false,
            oldId: "",
        }
    },
    methods: {
        ...mapActions(["getUplineByUser", "inquiryPicDealer", "changeTitleApp", "deleteAtasan", "addAtasan", "editAtasan",
            "inquiryUpline", "addUpline", "editUpline", "deleteUpline"]),

        handleDeleteUpline() {
            const arr = [];

            this.arrayToSaveDelete.map(item => {
                arr.push({
                    "upline": item
                })
            })
            this.deleteUpline({
                requestList: arr
            })
                .then(() => {
                    this.doneProcess = true
                    this.modeDelete = false
                    this.handleGetUplineByUserLogin()
                })
        },
        cancelProses() {
            this.doneProcess = true
            this.modeDelete = false
            this.handleGetUplineByUserLogin();
        },
        loadInquiryUpline() {
            this.inquiryUpline({
                name: this.namaUpline,
                nik: this.nikUpline,
                pageNumber: 0,
                pageSize: 10
            })
                .then((response) => {
                    this.uplineList = response.data.data;
                    if(this.uplineList == null) this.uplineList = []
                })
        },
        getValueUpline(value) {
            if (this.isEdit) {
                // this.detailUplineList.map(obj => this.oldId === obj.uplineId || obj);
                const target = this.detailUplineList.find((obj) => obj.uplineId === this.oldId);

                Object.assign(target, value);
            } else {
                this.detailUplineList.push(value)
            }
            this.idUpline = value.uplineId
            this.idUplineNik = value.oid + " - " + value.personName

            this.newUpline = value

            this.doneProcess = false

            this.dialogUpline = false
        },
        handleAddUpline() {
            if (this.isEdit) {
                this.editUpline({
                    newUpline: this.newUpline.uplineId,
                    oldUpline: this.oldId
                })
                    .then(() => {
                        this.dialogInputAtasan = false
                        this.handleGetUplineByUserLogin()
                    })
            } else {
                this.addUpline({
                    upline: this.newUpline.uplineId
                })
                    .then(() => {
                        this.doneProcess = true
                        this.handleGetUplineByUserLogin();
                    })
            }
        },

        handleAddAtasan() {
            if (this.isEdit) {
                this.editAtasan({
                    newID: this.idForDeleteAtasan,
                    oldID: this.oldId
                })
                    .then(() => {
                        this.dialogInputAtasan = false
                        this.handleGetUplineByUserLogin()
                    })
            } else {
                this.addAtasan({
                    internal_id: this.idForDeleteAtasan
                })
                    .then(() => {
                        this.dialogInputAtasan = false
                        this.handleGetUplineByUserLogin()
                    })
            }
        },
        getValueAtasan(value) {
            if (this.nik == value.nik) {
                this.$store.commit("setShowSnackbar", {
                    snackbarMsg: "Atasan sudah dipilih",
                    snackbarColor: "red",
                });
            } else {
                this.nama = value.name
                this.nik = value.nik
                this.accountNumber = value.accountNumber
                this.position = value.position
                // this.atasan[this.indexAtasan].dealer = value.dealer_code
                this.idForDeleteAtasan = value.internal_id

                this.dialogAtasan = false
            }
        },
        handleDeleteAtasan(id) {
            this.deleteAtasan({
                internal_id: id
            })
                .then(() => {
                    this.dialog = false
                    this.handleGetUplineByUserLogin()
                })
        },
        handleGetUplineByUserLogin() {
            this.getUplineByUser()
                .then((response) => {
                    this.detailUplineList = response.data.data;
                })
        },
        openDialog(oldId) {
            this.namaUpline = ""
            this.nikUpline = ""
            this.uplineList = []
            if (oldId != "") {
                this.isEdit = true
                this.oldId = oldId
            } else {
                this.isEdit = false
            }
            this.dialogUpline = true
        },
        loadInquiryPicDealer() {
            this.inquiryPicDealer({
                dealerCode: this.dealer,
                name: this.namaAtasan,
                nik: this.nikAtasan,
                pageNumber: 0,
                pageSize: 10
            })
                .then((response) => {
                    this.atasanList = response.data.data;
                    this.$store.commit("setShowSnackbar", {
                        snackbarMsg: response.data.message,
                        snackbarColor: "green",
                    });
                })
                .catch((error) => {
                    this.$store.commit("setShowSnackbar", {
                        snackbarMsg: error.response.data.message,
                        snackbarColor: "red",
                    });
                })
        },
        openDialogAtasan() {
            this.dialogAtasan = true
            this.atasanList = []
        },
    },
    mounted() {
        this.handleGetUplineByUserLogin();
    },
    computed: {
        ...mapState(["profile"]),
        dealer: function () {
            return this.profile.dealerCode;
        },
    },
    created() {
        this.changeTitleApp("Upline");
    },
}
</script>